import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC } from 'react';
import { useAppDispatch } from 'src/app/hooks';
import { removeModal } from 'src/features/globalSlice';
import { Modal } from 'src/store/models/Modal';

import classes from './BasicModal.module.scss';

export interface BasicModalProps {
  modal?: Modal;
}

const BasicModal: FC<BasicModalProps> = ({ modal }) => {
  const dispatch = useAppDispatch();

  return (
    <div className={classes.Container}>
      <header>
        <h5>{modal?.title}</h5>
        <FontAwesomeIcon
          icon={faTimes}
          onClick={() => dispatch(removeModal())}
        />
      </header>
      <div dangerouslySetInnerHTML={{ __html: modal?.body }} />
    </div>
  );
};

export default BasicModal;
